import { render } from "./TestimonialSection.vue?vue&type=template&id=3e3049b4"
import script from "./TestimonialSection.vue?vue&type=script&lang=js"
export * from "./TestimonialSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__